<script>
import isEmail from "validator/es/lib/isEmail";
import AuthBox from "./auth_box.vue";
import { passwordResetFormText } from "@/constants";
import VerifyPasswordResetModal from "@/components/auth/password-reset-modal.vue";

export default {
  name: "ForgotPasswordForm",

  components: {
    AuthBox,
    VerifyPasswordResetModal,
  },

  data() {
    return {
      email: "",
      errorMessage: "",
      successData: null,
      showEmailState: false,
    };
  },

  computed: {
    emailState() {
      return this.email.length === 0 ? null : isEmail(this.email);
    },
  },

  methods: {
    async onSubmit() {
      this.showEmailState = true;
      this.successData = null;
      this.errorMessage = "";

      if (!this.emailState) {
        this.errorMessage = this.$t(passwordResetFormText["invalidEmail"]);
        return;
      }

      try {
        const clerk = this.$getClerk();
        await clerk.client.signIn.create({
          identifier: this.email,
          strategy: "reset_password_email_code",
        });

        this.$bvModal.show("verify-password-reset-modal");

        this.successData = {
          title: this.$t(passwordResetFormText["successTitle"]),
          message: this.$t(passwordResetFormText["successMessage"]),
        };

        this.errorMessage = "";
        this.email = "";
      } catch (error) {
        this.errorMessage =
          error.message ||
          this.$t(passwordResetFormText["problemResettingPassword"]);
      }
    },
  },
};
</script>

<template>
  <auth-box
    :title="$t('auth.forgotPassword.title')"
    :error="errorMessage"
    :success-data="successData"
  >
    <div class="px-5">
      <eg-b-form
        class="mb-3"
        data-testid="forgot-password-form"
        @submit.prevent="onSubmit"
      >
        <eg-b-form-group
          id="email-group"
          :label="$t('auth.forgotPassword.emailLabel')"
          label-for="email-input"
          data-testid="email-group"
        >
          <eg-b-form-input
            id="email-input"
            v-model="email"
            type="text"
            :placeholder="$t('auth.forgotPassword.emailPlaceholder')"
            required
            :state="showEmailState ? emailState : null"
            data-testid="email-input"
          ></eg-b-form-input>
        </eg-b-form-group>

        <eg-b-button
          type="submit"
          variant="info"
          class="register-btn w-100"
          data-testid="submit-button"
        >
          {{ $t("auth.passwordReset.resetButton") }}
        </eg-b-button>
      </eg-b-form>

      <div class="divider"></div>

      <p class="mt-4 text-center" data-testid="back-to-login">
        {{ $t("common.back") }} {{ $t("common.to") }}
        <router-link to="/login">{{ $t("auth.login") }}</router-link>
      </p>
    </div>

    <verify-password-reset-modal />
  </auth-box>
</template>
